export const MAIN_CONTRACT = {
  role: "0xCd4D337554862F9bC9ffffB67465B7d643E4E3ad",
  pets: "0x997020483A30678436E76c08a65BBeCbE69Bf704",
  loot: "0xFF9C1b15B16263C61d017ee9F65C50e4AE0113D7",
  mloot: "0x1dfe7Ca09e99d10835Bf73044a23B73Fc20623DF",
  rolePlus: "0x96631f5F3871b2176EDf6CD9769Eb10EB2046713",
};

export const RINKEBY_CONTRACT = {
  role: "0x6f01C81a79044BF5bAdd165559FF9E6aD2154B4E",
  pets: "0xCd7149c31B45B1e894761a7b77d92169e2310CB4",
  loot: "0xdfbbCDf20FD1B1e9582Db247e75657a970b87940",
  mloot: "0xb52F620F5d33a42a363dB8f4905f344a89412e10",
  rolePlus: "0xC8024fc5155dDF75735F40E23e6296c18a93D74F",
};
